import type { PlayerAchievementsAwardsResponse } from '@/api/generated/models'
import type { Achievement, Award } from '../types'

export function mapAchievements(api: PlayerAchievementsAwardsResponse): {
  achievements: Achievement[]
  awards: Award[]
} {
  const awards: Award[] = (api.awards ?? []).map(a => ({
    season: a.season,
    label: a.abbr ? `${a.award} (${a.abbr})` : (a.award ?? ''),
  }))

  const achievements: Achievement[] = (api.achievements ?? []).map(a => ({
    season: undefined,
    label: a.achievement ?? '',
  }))

  return { achievements, awards }
}
